import styled from 'styled-components';
import { layout } from 'styled-system';
import { Box } from '@cowsquare/design';

export const BreadcrumbWrapper = styled(Box).attrs({
  mt: 5,
  display: ['none', 'block'],
})`
  ${layout}
`;
